import { render, staticRenderFns } from "./Contenedor.vue?vue&type=template&id=fd9df52a"
import script from "./Contenedor.vue?vue&type=script&lang=js"
export * from "./Contenedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports